// extracted by mini-css-extract-plugin
module.exports = {"callout":"text-callout_callout__3Q9g0","calloutTitle":"text-callout_calloutTitle__3OORx","calloutContent":"text-callout_calloutContent__30M0b"};